export default "__VITE_ASSET__BCWuGUTl__";